


























































import moment from 'moment';
import { DatacollectDto, StreamTunnelInfo } from '@/services/datacollect';
import { Vue, Component, PropSync, Prop, Watch } from 'vue-property-decorator';

@Component
export default class DatacollectForm6 extends Vue {
  @PropSync('tunnelInfo') syncTunnelInfo!: StreamTunnelInfo;
  @Prop() dsType!: string;
  time = moment('00:00:00', 'HH:mm:ss');
  date = moment().format('YYYY-MM-DD');

  startupModeList = ['group-offsets', 'earliest-offset', 'latest-offset', 'timestamp', 'specific-offsets'];
  incrementType = ['自增主键', '时间'];

  created() {
    this.onSyncTunnelInfoChange();
  }

  @Watch('syncTunnelInfo')
  onSyncTunnelInfoChange() {
    if (this.syncTunnelInfo.startupTimestamp) {
      let startupTimestamp =  new Date(this.syncTunnelInfo.startupTimestamp);
      this.date = moment(startupTimestamp).format('YYYY-MM-DD');
      this.time = moment(startupTimestamp, 'HH:mm:ss');
    }
    if(this.syncTunnelInfo.incrementType == 0) {
      delete this.syncTunnelInfo.incrementType;
    }
  }

  changeTimeOffset() {
    let timeStr = this.time.format('HH:mm:ss');
    this.syncTunnelInfo.startupTimestamp = new Date(`${this.date} ${timeStr}`).getTime();
  }

  changeMode() {
    if (this.syncTunnelInfo.startupMode) {
      if (['group-offsets','earliest-offset','latest-offset'].includes(this.syncTunnelInfo.startupMode) ) {
        this.time = moment('00:00:00', 'HH:mm:ss');
        this.date = moment().format('YYYY-MM-DD');
        this.syncTunnelInfo.startupTimestamp = 0;
        this.syncTunnelInfo.startupOffset = '';
      } else if (this.syncTunnelInfo.startupMode == 'specific-offsets') {
         this.time = moment('00:00:00', 'HH:mm:ss');
        this.date = moment().format('YYYY-MM-DD');
        this.syncTunnelInfo.startupTimestamp = 0;
      }
    }

  }

}
